<div
  (click)="tileClicked()"
  class="tile-count-component"
  [ngStyle]="{ background: color }"
>
  <div class="tile-count-number">
    <h2>{{ count }}</h2>
  </div>
  <div class="tile-count-title">
    {{ title }}
  </div>
</div>
